import { render, staticRenderFns } from "./UserInjuryAdd.vue?vue&type=template&id=53108cfc&"
import script from "./UserInjuryAdd.vue?vue&type=script&lang=js&"
export * from "./UserInjuryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports